import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.games_tab,
    (games_tab) => {
        return {
            games_tab
        }
    }
)